export const EXECUTOR_PROJECT_STATUS_INCOMPLETE_OVERDUE = 'incomplete-overdue';
export const EXECUTOR_PROJECT_STATUS_INCOMPLETE = 'incomplete';
export const EXECUTOR_PROJECT_STATUS_COMPLETED = 'completed';
